import { render, staticRenderFns } from "./Separator.vue?vue&type=template&id=db3b207e&scoped=true&"
import script from "./Separator.vue?vue&type=script&lang=js&"
export * from "./Separator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db3b207e",
  null
  
)

export default component.exports